import { Entity, Subscription } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { interval } from 'rxjs';
import { map, share } from 'rxjs/operators';

const serverTimer = interval(1000).pipe(
  map(_ => new Date()),
  share(),
);

@Entity()
export class ServerTime extends AdornisEntity {
  public static override _class = 'ServerTime';

  @Subscription(type => Date)
  public static subscribeServerTime() {
    return () => serverTimer;
  }
}
